import { Component, Event, EventEmitter, h, Prop, State } from '@stencil/core';
@Component({
  tag: 'biel-feedback',
  styleUrl: 'biel-feedback.css',
  shadow: true,
})
export class BielFeedback {
  @Prop() messageId: string;
  @Prop() initialReaction?: 0 | 1;
  @Prop() bielId: string;

  @State() reaction: 0 | 1; // 0 = Dislike, 1 = Like

  @Event() feedbackSent: EventEmitter<{ bielId: string; messageId: string; reaction: 0 | 1 }>;

  componentWillLoad() {
    if (this.initialReaction !== undefined) {
      this.reaction = this.initialReaction;
    }
  }

  handleReaction(reaction: 0 | 1) {
    if (this.messageId && this.reaction !== reaction) {
      this.reaction = reaction;
      this.feedbackSent.emit({
        bielId: this.bielId,
        messageId: this.messageId,
        reaction: this.reaction,
      });
    }
  }

  render() {
    return (
      <div class="biel-feedback-container">
        <div class="biel-feedback-reaction">
          <button
            class={`biel-feedback-btn like-btn ${this.reaction === 1 ? 'active' : ''}`}
            onClick={() => this.handleReaction(1)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-thumbs-up"
            >
              <path d="M7 10v12" />
              <path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z" />
            </svg>
          </button>
          <button
            class={`biel-feedback-btn dislike-btn ${this.reaction === 0 ? 'active' : ''}`}
            onClick={() => this.handleReaction(0)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-thumbs-down"
            >
              <path d="M17 14V2" />
              <path d="M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z" />
            </svg>
          </button>
        </div>
      </div>
    );
  }
}
